"use client";

import { ProductCard, type ChatProduct } from "./product-card";

interface ProductCardGridProps {
  products: ChatProduct[];
}

export function ProductCardGrid({ products }: ProductCardGridProps) {
  if (!products || products.length === 0) return null;

  return (
    <div className="mt-3">
      <div className="flex items-center gap-2 mb-2">
        <h4 className="text-sm font-medium text-muted-foreground">
          Products we found for you
        </h4>
        <span className="text-xs text-muted-foreground">
          ({products.length} {products.length === 1 ? "result" : "results"})
        </span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {products.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </div>
  );
}
